// Launch from the Petals Platform tile: /?sso=1[&org=<alias>] starts Petals sign-in at once,
// before any session check, so the CodeCraft login page never shows and the CodeCraft session is
// always the Platform user's. Every other visit keeps the normal sign-in page.
// Pure (no imports): app/test/unit/sso-launch.test.mjs runs it under plain node.

const ORG_ALIAS_RE = /^[a-z0-9][a-z0-9-]{0,62}$/;     // Petals organization alias

/** {org} for a Platform launch (org null when absent or malformed), otherwise null. */
export const platformLaunch = (search, ssoMode) => {
    if (ssoMode === 'local') return null;
    const p = new URLSearchParams(search);
    if (p.get('sso') !== '1' || p.get('sso_error')) return null;   // an SSO error never loops
    const org = p.get('org');
    return {org: org && ORG_ALIAS_RE.test(org) ? org : null};
};
